import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  OptionType,
  getOptionsMessages
} from '@/presentation/modules/procedures/modules/requests/FullCycleDiscount/components/OptionsMessages';
import { Creators as activateBenefitActions } from '@/domain/useCases/payments/activateBenefitInstallments';

const useBenefitActivation = () => {
  const dispatch = useDispatch();
  const [showModal, setShowModal] = useState(false);
  const [isActivating, setIsActivating] = useState(false);
  const [optionMessage, setOptionMessage] = useState<OptionType | null>(null);
  const {
    data: benefitFullCycleData,
    isLoading: isLoadingProgress,
    error: errBenefitFullCycle
  } = useSelector((state: any) => state.activateBenefitInstallments);

  useEffect(() => {
    if (errBenefitFullCycle) {
      setOptionMessage(getOptionsMessages().error);
      return;
    }
    if (!benefitFullCycleData || isLoadingProgress) return;

    const { validationError, success } = benefitFullCycleData;
    const errUnexpected = !success && !validationError;

    setShowModal(!!validationError || !!success || errUnexpected);

    if (validationError) {
      const { title, description } = validationError;
      setOptionMessage(
        isActivating
          ? getOptionsMessages(title, description).errorActivate
          : getOptionsMessages(title, description).errorDeactivate
      );
    } else if (success) {
      setOptionMessage(
        isActivating
          ? getOptionsMessages().successActivate
          : getOptionsMessages().successDeactivate
      );
    } else if (errUnexpected) {
      setOptionMessage(getOptionsMessages().error);
    }
  }, [benefitFullCycleData, isLoadingProgress, isActivating]);

  useEffect(() => {
    setShowModal(!!optionMessage);
  }, [optionMessage]);

  const toggleBenefit = (isActivate: boolean) => {
    setIsActivating(isActivate);
    dispatch(activateBenefitActions.activateBenefitInstallmentsClear());
    dispatch(activateBenefitActions.activateBenefitInstallments(isActivate));
  };

  const resetModal = () => {
    setShowModal(false);
    setOptionMessage(null);
  };

  return {
    showModal,
    optionMessage,
    isLoadingProgress,
    resetModal,
    toggleBenefit
  };
};

export default useBenefitActivation;
